<template>

<div v-if="data" class="contentWrapper" v-bind:style="{ width: settings.width+'%' }">

    <div class="prop-wrap">

        <div :class="[{'bordered':  settings.isBordered }, 'prop-inner']">

            <!-- INTRO -->
            <div class="apopediaIntro">{{ contentElementData[0].value }}</div>

            <!-- TITLE -->
            <h1 class="title">{{ contentElementData[1].value }}</h1>

            <!-- INTRO TEXT -->
            <div class="apopediaIntroText">{{ contentElementData[2].value }}</div>

            <!-- TEXT -->
            <div class="apopediaText">{{ contentElementData[3].value }}</div>

            <!-- IMAGES -->
            <div class="apopediaImages is-clearfix">
                <template v-for="el in contentElementData[4].assets">
                    <img class="lazy-img-fadein is-pulled-left" v-lazy="$config.assets + el.asset.path + '/' + el.asset.filename" />
                </template>
            </div>

        </div>

    </div>

</div>

</template>



<script>

export default {

    props: ['data', 'settings'],

    data(){
		return {
            contentElementData: []
		}
	},

    created() {
        this.contentElementData = this.data.contentElement.contentElementData;
    },

    mounted() {
        // console.log(this.data);
    },

}

</script>



<style scoped>

.apopediaIntro {
    font-size: 75%;
    margin: 0 0 3% 0;
    color: #666;
    padding: 2%;
    border: 1px dotted #aaa;
}

.apopediaIntroText {
    color: #666;
    margin: 3% 0;
    font-style: italic;
}

.apopediaText {

}
.apopediaImages {

}
.apopediaImages img {
    max-width: 50%;
    height: auto;
}

</style>
